<template>
    <div slot="description" class="main">
        <div class="content">
            <p v-html="parse(item.text)" class="renderText"></p>
            <p class="bottom">
                {{item.pid}} 楼
                    | 发表于 {{ formatDate(item.replytime) }}
                <span v-if="item.updatetime > item.replytime">
                    | 最后编辑于 {{ formatDate(item.updatetime) }}
                </span>
                <a-button type="link" @click="triggerWriteboard()">{{ open ? '收起回复' : '回复' }}</a-button>
                <a-button v-if="userid == item.authorid" type="link" @click="editPost()">编辑</a-button>
                <a-button v-if="userid == item.authorid" type="link" @click="deletePost()">删除</a-button>
            </p>
        </div>
        <div v-if="item.replies.length > 0 || open">
            <a-list
                bordered size="small"
                class="lzl-list"
                item-layout="horizontal"
                :data-source="item.replies"
            >
                <a-list-item slot="renderItem" slot-scope="reply">
                    <a-list-item-meta>
                        <a-avatar slot="avatar" :src="reply.avatar" shape="square" class="reply-avatar"/>
                        <div slot="description" class="reply-main">
                            <p>
                                <user-link :name="reply.author" :id="reply.authorid"/>:
                                {{ reply.text }}
                            </p>
                            <p class="reply-bottom">
                                {{ formatDate(reply.time) }}
                                <a-button type="link" @click="openWriteboard(reply.author)">回复</a-button>
                                <a-button v-if="userid == reply.authorid" type="link" @click="deletelzlreply(reply.id)">删除</a-button>
                            </p>
                        </div>
                    </a-list-item-meta>
                </a-list-item>
                <div class="writeboard" v-if="open">
                    <a-textarea v-model="text" auto-size></a-textarea>
                    <div class="textbar">
                        <span class="counter" :class="{ warn: overflow }">{{ text.length }} / 140</span>
                        <a-button type="primary" size="small" @click="dolzlreply()"
                            :disabled="overflow" :loading="replying"
                        >发送</a-button>
                    </div>
                </div>
            </a-list>
        </div>
    </div>
</template>

<script>
import UserLink from '@/components/UserLink.vue';
import axios from 'axios';
import { mapState } from 'vuex';
import { createFormData } from '../../utils/utils';

export default {
    props: {
        item: Object,
    },
    data: () => ({
        open: false,
        text: "",
        replying: false,
    }),
    computed: {
        ...mapState({ userid: 'userid' }),
        overflow() {
            return this.text.length > 140;
        }
    },
    methods: {
        formatDate(timestamp) {
            return (new Date(timestamp * 1000)).toLocaleString("cn-ZH", { hour12: false });
        },
        /**
         * @param {string}raw
         */
        parse(raw, space = true) {
            if (!space)
                raw = raw.replace(/ /, "&nbsp;");
            return raw
                .replace(/\n<br>/g, "<br>")
                .replace(/[\n\r]/g, "<br>");
        },
        triggerWriteboard() {
            this.open = !this.open;
        },
        openWriteboard(text) {
            this.open = true;
            this.text = `回复 @${text}: `
        },
        dolzlreply() {
            this.replying = true;
            const fid = this.item.fid, text = this.text;
            axios.post("/backend/bbs/reply.php", createFormData({
                fid, text, 
            })).then(({ data }) => {
                this.replying = false;
                if (data.code == 0) {
                    this.$message.success('发布成功');
                    window.location.reload();
                } else {
                    alert(data.msg);
                }		
            });
        },
        editPost() {
            this.$emit('edit', { pid: this.item.pid, text: this.item.text });
        },
        deletePost() {
            const { bid, tid, pid } = this.item;
            this.$confirm({
                title: '确认要删除帖子吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                onOk: async() => {
                    const { data } = await axios
                        .post("/backend/bbs/delete.php", createFormData({
                            bid, tid, pid
                        }));
                    if (data.code == 0) {
                        this.$message.success('删除成功');
                        window.location.reload();
                    } else {
                        alert(data.msg);
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        },
        deletelzlreply(id) {
            const { fid } = this.item;
            this.$confirm({
                title: '确认要删除回复吗？',
                content: h => <div style="color:red;">一旦删除后无法恢复</div>,
                async onOk() {
                    const { data } = await axios
                        .post("/backend/bbs/deletelzl.php", createFormData({
                            fid, id
                        }));
                    if (data.code == 0) {
                        window.location.reload();
                    } else {
                        alert(data.msg);
                    }
                },
                onCancel() {
                    console.log('Cancel');
                },
            });
        }
    },
    components: {
        UserLink
    }
}
</script>
<style lang="less" scoped>
.main {
    .content {
        min-height: 100px;
        display: flex;
        flex-direction: column;
        text-align: left;
    }
    .bottom {
        margin-top: auto;
        margin-bottom: -10px;
        text-align: right;
    }
}
.lzl-list {
    margin-top: 10px;
}
.reply-avatar {
    margin-top: 4px;
    @media screen and (max-width: 599px) {
        display: none;
    }
}
.reply-main {
    text-align: left;
    p {
        margin: 0;
    }
    .reply-bottom {
        text-align: right;
    }
}
.writeboard {
    margin: 10px 15px;
    .ant-input {
        margin-bottom: 5px;
    }
    .textbar {
        .counter {
            &.warn {
                color: red;
            }
            margin: 0 5px;
        }
        .ant-btn {
            span {
                margin: 0px 10px;
            }
        }
        text-align: right;
    }
}
.ant-btn {
    span {
        margin: 0px 8px;
    }
    padding: 0 6px;
}
</style>

<style lang="less">
.renderText {
    color: #444444;
    img {
        max-width: 100%;
    }
    blockquote {
        display: block;
        border-left: 8px solid #d0e5f2;
        padding: 5px 10px;
        margin: 10px 0;
        line-height: 1.4;
        font-size: 100%;
        background-color: #f1f1f1;
        p {
            margin: 10px 0;
            line-height: 1.5;
        }
    }
}
.ant-list-item-meta-avatar {
    a {
        margin-top: 10px;
        font-size: 14px;
    }
}
.ant-modal-mask, .ant-modal-wrap {
    z-index: 10001 !important;
}
</style>
